import './style.scss';

import {
	GradientPicker as WPGradientPicker,
	Popover,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import React, { useState } from 'react';

import { GradientPickerProps } from './types';

export const GradientPicker: React.FC< GradientPickerProps > = ( {
	value,
	onChange,
	className = '',
} ) => {
	const [ isOpen, setIsOpen ] = useState( false );

	const triggerRef = React.useRef< HTMLButtonElement >( null );

	const handleGradientChange = ( gradient: string | undefined ) => {
		onChange( gradient );
		// Optionally close popover after selection
		// setIsOpen(false);
	};

	return (
		<div className={ `redfox-thank-you-gradient-picker ${ className }` }>
			<div className="redfox-thank-you-gradient-picker__controls">
				<button
					type="button"
					className="redfox-thank-you-gradient-picker__trigger"
					onClick={ () => setIsOpen( ! isOpen ) }
					style={ {
						// @ts-expect-error: Allow custom CSS property
						'--redfox-thank-you-gradient-picker':
							value ?? 'transparent',
					} }
					aria-label={ __(
						'Open gradient picker',
						'redfox-thank-you',
					) }
					ref={ triggerRef }
				/>
			</div>

			{ isOpen && (
				<Popover
					placement="left-start"
					onClose={ () => setIsOpen( false ) }
					anchor={ triggerRef.current }
					className="redfox-thank-you-gradient-picker__popover"
					offset={ 20 }
				>
					<div className="redfox-thank-you-gradient-picker__content">
						<WPGradientPicker
							value={ value }
							onChange={ handleGradientChange }
							clearable
						/>
					</div>
				</Popover>
			) }
		</div>
	);
};
